import styled from 'styled-components'

export const Wrapper = styled.div`
  min-height: calc(100vh - 64px);
`
